export type NotificationType =
  | 'credits_low'
  | 'credits_added'
  | 'credits_expiring'
  | 'task_completed'
  | 'task_failed'
  | 'video_ready'
  | 'welcome'
  | 'promo'
  | 'system';

export interface Notification {
  id: number;
  type: NotificationType;
  title: string;
  message: string;
  data?: Record<string, unknown>;
  actionUrl?: string;
  readAt?: string;
  createdAt: string;
}

export interface NotificationApiResponse {
  id: number;
  type: NotificationType;
  title: string;
  message: string;
  data?: Record<string, unknown>;
  actionUrl?: string;
  action_url?: string;
  readAt?: string;
  read_at?: string;
  createdAt?: string;
  created_at?: string;
}

export function mapNotificationFromApi(apiNotification: NotificationApiResponse): Notification {
  return {
    id: apiNotification.id,
    type: apiNotification.type,
    title: apiNotification.title,
    message: apiNotification.message,
    data: apiNotification.data,
    actionUrl: apiNotification.actionUrl || apiNotification.action_url,
    readAt: apiNotification.readAt || apiNotification.read_at,
    createdAt: apiNotification.createdAt || apiNotification.created_at || new Date().toISOString(),
  };
}
